import loadable from '@loadable/component';
import { WithLazyHydration } from '../WithLazyHydration';

const MostPopularContentLoadable = loadable(
  () => import('./MostPopularContent'),
  {
    resolveComponent: components => components.MostPopularContent
  }
);

export const MostPopularContent = WithLazyHydration(
  MostPopularContentLoadable,
  { name: 'MostPopularContent' }
);
